import React, { useState } from "react";
import ToggleSwitch from "../../ToggleSwitch";
import EditOrAddPTAndLWF from "../EditOrAddPTAndLWF/EditOrAddPTAndLWF";
import { useSelector } from "react-redux";
import userRoleAuth from "../../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../../config/userRoles";
import { useGetEmployeePTAndLWF } from "../../../queries/employeeQueries";
const ProfessionalTaxInfo = ({ employee }) => {
  const [openModal, setOpenModel] = useState(false);
  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);
  const loggedInUser = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(loggedInUser, userRoles.HR);
  const isAdmin = userRoleAuth(loggedInUser, userRoles.TENANTADMIN);
  const isFinanceAdmin = userRoleAuth(loggedInUser, userRoles.FINANCEADMIN);
  const isAdminOrHROrFinanceAdmin = isHr || isAdmin || isFinanceAdmin;
  const { data: pfAndLwfData } = useGetEmployeePTAndLWF({
    employee_id: employee?.employee_id,
  });
  const pfAndLwfDataDetails = pfAndLwfData?.data?.[0] || {};
  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-3">
          <img src="/images/basic-info-icon.svg" alt="" />

          <p className="text-base text-[#1F2937] font-semibold">
            Profesional Tax & LWF
          </p>
        </div>
        {isAdminOrHROrFinanceAdmin && (
          <div className="cursor-pointer">
            <img
              src="/images/editicon.svg"
              alt=""
              onClick={() => onOpenModal()}
            />
            <EditOrAddPTAndLWF
              openModal={openModal}
              onCloseModal={onCloseModal}
              employee={{ ...employee, pt_lwf_details: pfAndLwfDataDetails }}
            />
          </div>
        )}
      </div>
      <div className="flex justify-between employee-info-card">
        <table className="border-0">
          <tbody>
            <tr>
              <td className="title">Professional Tax </td>
              <td className="data py-2">
                <span
                  className={`px-3 py-1 rounded-full font-medium text-sm ${
                    pfAndLwfDataDetails?.professional_tax_enabled
                      ? "bg-green-200 text-black"
                      : "bg-yellow-200 text-black"
                  }`}
                >
                  {pfAndLwfDataDetails?.professional_tax_enabled
                    ? "Active"
                    : "In-Active"}
                </span>
              </td>
            </tr>
            <tr>
              <td className="title">Labour Welfare Fund </td>
              <td className="data py-2">
                <span
                  className={`px-3 py-1 rounded-full font-medium text-sm ${
                    pfAndLwfDataDetails?.lwf_enabled
                      ? "bg-green-200 text-black"
                      : "bg-yellow-200 text-black"
                  }`}
                >
                  {pfAndLwfDataDetails?.lwf_enabled ? "Active" : "In-Active"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProfessionalTaxInfo;
